export default __webpack_public_path__ + "static/media/vintage100-5.b22da8df.jpg";